import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";

import { useVendorWallet } from "hooks/useVendorWallet";
import { formatMoney } from "utils/money";
import "components/Vendors/VendorWallet/vendorWallet.scss";
import "./vendorWalletBanner.scss";

/**
 * The closure notice at the top of every page of a restaurant's dashboard
 * (admin#41).
 *
 * A restaurant the wallet has closed simply stops getting orders. Without this
 * line nothing on its screens would say why. It reads the SAME query as the
 * «المحفظة» page (page 1), so the two share one request and cannot disagree,
 * and it refreshes on focus: never a stale "closed" after a top-up, never a
 * stale "open" after the last credit went.
 *
 * Renders nothing for an admin, and nothing while the wallet is not blocking.
 */
const VendorWalletBanner = () => {
    const adminInfo = useSelector((state) => state.auth.userData);
    const isVendor = adminInfo?.role === "vendor";
    const { wallet } = useVendorWallet(isVendor ? adminInfo?.id : null, 1, {
        refreshOnFocus: true,
    });

    if (!isVendor || !wallet?.blocked) return null;

    const balance = Number(wallet.balance ?? 0);

    return (
        <div className="vendor-wallet-banner" role="alert">
            <FontAwesomeIcon icon={faLock} />
            <span>
                <strong>{wallet.blocked_reason}</strong>
                {" — "}
                الرصيد {formatMoney(balance)}. يجب أن يكون رصيد المحفظة أكبر من صفر لفتح المطعم.
            </span>
            <NavLink to="/wallet">عرض المحفظة</NavLink>
        </div>
    );
};

export default VendorWalletBanner;
